import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const SettingsLayout = () => {
  const navList = useNav();
  let { SettingsBottomHeader, SettingsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={SettingsBottomHeader} topTabs={SettingsTopHeader} />
      <Outlet />
    </div>
  );
};

export default SettingsLayout;
